import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

export const TransactionSummaryLayout: React.FC = ({ children }) => {
  return (
    <Box sx={{ bgcolor: "background.default" }}>
      <Container maxWidth="xl" sx={{ pt: { xs: 0, lg: 4 }, pb: 0 }}>
        {children}
      </Container>
    </Box>
  );
};

export default TransactionSummaryLayout;
